var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBhutan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1422 34.1421C26.3317 41.9526 13.6684 41.9526 5.85785 34.1421C-1.95262 26.3317 -1.95262 13.6683 5.85785 5.85775C5.86067 5.85775 23.8311 0.547832 31.6417 8.3583C39.4522 16.1688 34.1475 34.1367 34.1422 34.1421Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1421 34.1421C41.9526 26.3317 41.9526 13.6683 34.1421 5.85776C26.3316 -1.95279 13.6683 -1.95271 5.85779 5.85776L34.1421 34.1421Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2278 25.2297C24.4062 25.5524 23.4516 25.5181 22.6234 25.0534C21.1602 24.2321 20.6378 22.3732 21.4593 20.9097L21.2099 20.7699C23.7155 20.1657 25.5691 17.8915 25.5366 15.2077C25.5165 13.5392 24.7709 12.0465 23.6048 11.0251L21.7787 12.8959C22.4691 13.446 22.9166 14.2899 22.9281 15.2394C22.9484 16.9175 21.5998 18.2993 19.9218 18.3195L19.9253 18.6052C18.1493 16.7376 15.253 16.2694 12.9451 17.6394C11.5103 18.4913 10.5905 19.8831 10.2888 21.4038L12.8219 22.0499C12.9533 21.177 13.4602 20.3674 14.2767 19.8827C15.7198 19.026 17.5907 19.5032 18.4473 20.9462L18.6933 20.8003C17.9637 23.272 19.0063 26.0145 21.3469 27.3282C22.802 28.1449 24.4673 28.2456 25.9352 27.7465L25.2278 25.2297ZM19.9428 20.0583L19.9427 20.0584L19.9428 20.0583Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4051 13.5453L25.9915 18.59L21.7501 17.8068L19.0199 12.179L11.6444 14.7963L11.0627 13.1572L9.13306 12.9195L10.587 17.0171L15.6627 15.7189L17.1052 19.7837L13.5964 24.9619L19.5509 30.0405L18.4222 31.3637L19.1812 33.1539L22.0029 29.8458L18.3409 26.0992L21.1399 22.8177L27.3788 23.2672L28.7998 15.5711L30.51 15.887L31.681 14.3346L27.4051 13.5453ZM19.9984 20.136V20.1362V20.136Z",
    fill: "#FFEACF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBhutan);
export default __webpack_public_path__ + "static/media/bhutan.2f8ce587a63be3cc17b2cdf03d3654fb.svg";
export { ForwardRef as ReactComponent };